Ext.define('SA.controller.SimmonsCrosstabController', {
    extend: 'SA.ViewController',

    constructor() {
        this.callParent(arguments);

        this.mon(SA.AppController, 'switch:projectView', this.syncFromModel, this);
        this.mon(this.model.getProject(), 'change:attribute', this.syncFromModel, this);
        this.mon(this.model, 'change:name', this.syncFromModel, this);
        this.mon(this.model, 'change:attribute', this.syncFromModel, this);
    },

    createDefaultView() {
        this.toolbar = new SA.view.CrosstabToolbar({model: this.model});

        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);

        return SA.ProjectView.createHidden({xtype: 'crosstab-view', projectView: this.model});
    },

    createEditView() {
        this.editController = new SA.SimmonsCrosstabEditController(this.getEditControllerParams());

        return SA.ProjectView.createHidden(this.editController.getView());
    },

    getTableController() {
        var params = {model: this.model, toolbar: this.toolbar, view: this.projectViews.getViewModeItem()},
            controller = this.tableController = (this.tableController || new SA.CrosstabTableController(params));

        return controller;
    },

    onActivateExportBtn(toolbarButton) {
        var config = new SA.CrosstabExportConfig({model: this.model});

        Ext.widget({xtype: 'arrow-export-menu', config, toolbarButton});
    },

    onActive() {
        SA.SidebarState.create()
            .enableTabs(['data'])
            .selectTab('data')
            .setModel(this.model)
            .apply();
    },

    refreshModeIndicator() {
        var text = `Simmons NCS Crosstab Data (National-Level): ${this.model.getYear()}`;

        if (this.model.hasLatestYear()) {
            text += ' (Latest)';
        }

        SA.ModeIndicator.set({text, visible: true});
    },

    syncFromModel() {
        if (!this.isActive() || this.isEditMode()) {
            return;
        }

        this.getTableController().syncFromModel();
    }
});